import { useState, useEffect } from 'react';
import { usePublicPlans, useSwitchPlanMutation } from '@hooks/useAuthMutations';

export const PLAN_CARD_COLORS = [
    { header: '#FACC15', text: '#B45309', label: 'Free' },
    { header: '#3B82F6', text: '#1D4ED8', label: 'Starter' },
    { header: '#8B5CF6', text: '#5B21B6', label: 'Pro' },
    { header: '#EC4899', text: '#BE185D', label: 'Enterprise' },
];

export const isPlanFree = (p) => {
    const amount = p.afterDiscountAmount ?? p.amount ?? 0;
    return (
        amount === 0 ||
        p.key === 'free' ||
        String(p.name || '')
            .toLowerCase()
            .includes('free')
    );
};

export const useOpenMarketUpgrade = (upgradeMessage) => {
    const [showPlans, setShowPlans] = useState(false);
    const [selectedPlanKey, setSelectedPlanKey] = useState(null);
    const { data: plans = [], isLoading: plansLoading } = usePublicPlans();
    const switchPlanMutation = useSwitchPlanMutation();

    const freePlan = plans.find((p) => isPlanFree(p));
    const freePlanKey = freePlan?.key ?? freePlan?.id ?? null;
    const isPaidPlanSelected = selectedPlanKey && selectedPlanKey !== freePlanKey;

    useEffect(() => {
        if (showPlans && plans.length > 0 && selectedPlanKey === null && freePlanKey) {
            setSelectedPlanKey(freePlanKey);
        }
    }, [showPlans, plans.length, freePlanKey, selectedPlanKey]);

    const handleContinue = () => {
        if (!selectedPlanKey || !isPaidPlanSelected) return;
        switchPlanMutation.mutate(
            { planKey: selectedPlanKey },
            {
                onSuccess: () => {
                    setSelectedPlanKey(freePlanKey);
                },
            },
        );
    };

    return {
        showPlans,
        setShowPlans,
        selectedPlanKey,
        setSelectedPlanKey,
        plans,
        plansLoading,
        freePlanKey,
        isPaidPlanSelected,
        handleContinue,
        switchPlanMutation,
        upgradeMessage,
    };
};
